import { ITask, ConversationState } from "@twilio/flex-ui";
import * as Flex from "@twilio/flex-ui";
import ProgrammableChatService from "../../../utils/ProgrammableChatService";
import { InvitedParticipants } from "../types/InvitedParticipantDetails";



// This is to handle removing any invite by task sid for a channel
export const removeInvitedParticipant = async (
  manager: Flex.Manager,
  conversation: ConversationState.ConversationState,
  taskSid: string
) => {
  const currentAttributes = conversation?.source?.attributes as object;

  const { invites = {} } = (currentAttributes as any) || {};

  const updatedInvites = JSON.parse(JSON.stringify(invites));
  delete updatedInvites[taskSid];

  const updatedAttributes = {
    ...currentAttributes,
    invites: updatedInvites
  };

  if (conversation?.source?.sid)
    try {
      await new ProgrammableChatService(manager).updateChannelAttributes(
        manager,
        conversation?.source?.sid,
        updatedAttributes
      );
    } catch (error) {
      console.log("Error", error, conversation);
    }
};

// This is to handle removing an invite afer WE join the channel
export const checkAndRemoveOldInvitedParticipants = async (
  manager: Flex.Manager,
  task: ITask,
  conversation: ConversationState.ConversationState
) => {
  const currentAttributes = conversation?.source?.attributes;
  const { invites = {} } = (currentAttributes as any) || {};

  if (invites[task.taskSid]) {
    await removeInvitedParticipant(manager, conversation, task.taskSid);
  }
};

export const countOfOutstandingInvitesForConversation = (conversation: ConversationState.ConversationState): number => {
  const { invites = undefined } = (conversation?.source?.attributes as any as InvitedParticipants) || {};
  return Object.keys(invites || {}).length;
};
